import React from "react";
import Pagination from "../Pagination/Pagination";

const DocumentsResult = (props) => {
    return (
        <div
            className={"tab-pane fade show " + (props.initialTab === "documents" ? "active" : "")}
            id="pills-documents"
            role="tabpanel"
            aria-labelledby="pills-documents-tab"
        >
            {props.documents?.length > 0 ? (
                <>
                    {/* Pagination */}
                    <Pagination
                        handlePageChange={props.handleChange}
                        currentPage={props.documentsPage}
                        pagination={props.pagination}
                    />

                    {/* Results */}
                    <ul className="c-quick-search__result">
                        {props.documents.map((item, i) => {
                            return (
                                <li className="item document-result-item">
                                    <a href={"https://www.cejn.com" + item.url} target="_blank">
                                        <i class="icon-file-alt"></i>
                                        {item.title && <p>{item.title} {item.description && <span>{item.description}</span>}</p>}
                                        {/*{item.description && <span>{item.description}</span>}*/}
                                    </a>
                                </li>
                            );
                        })}
                    </ul>
                </>
            ) : (
                <div class="no-results-container">{i18n.getString("quicksearch.nomatchingresults")}</div>
            )}
        </div>
    );
};

export default React.memo(DocumentsResult);
